import axios from 'axios'
import AppError from './errors/app-errors'
import { getCdnBaseUrl } from './utils'
import { cancelHTTPRequests } from '@/services/utils'
import store from '../store'

export async function getBotJSONConfig(botRefId) {
  const config = {
    url: `json-config/${botRefId}.json`,
    errorName: 'botJsonConfig',
    errorMessage: 'Error while fetching Bot JSON'
  }
  return await fetchFromCDNWrapper(config)
}

export async function getBotConstantTranslations(lang_code) {
  const botRefId = store.state.botRefId
  const config = {
    url: `${botRefId}/language/constant/${lang_code}.json`,
    errorName: 'languageConfig',
    errorMessage: `Error while fetching bot constants ${lang_code} language.json`
  }
  return await fetchFromCDNWrapper(config)
}

export async function getBotJsonTranslations(lang_code) {
  const botRefId = store.state.botRefId
  const config = {
    url: `${botRefId}/language/configurable/translation-${lang_code}.json`,
    errorName: 'languageConfig',
    errorMessage: `Error while fetching bot json ${lang_code} language.json`
  }
  return await fetchFromCDNWrapper(config)
}

export async function getFormEncryptionPublicKey() {
  const config = {
    url: `form-constant/cw-form-encryption-public-key.pem`,
    errorName: 'formEncryptionPublickKey',
    errorMessage: `Error while fetching form encryption public key`
  }
  return await fetchFromCDNWrapper(config)
}

async function fetchFromCDNWrapper({url, errorName, errorMessage}) {
  let result = {}
  try {
    const CDNConfigUrl = getCdnBaseUrl()
    const http = axios.create({
      baseURL: new URL(CDNConfigUrl).origin,
      headers: {
        'Content-Type': 'application/json'
      },
      params: {}
    })
    const response = await http.request({
      method: 'get',
      url: `${url}?t=${Date.now()}`, //for always fetching latest resource from S3.
      options: {
        headers: {
          'Cache-Control': 'no-cache'
        }
      },
      cancelToken: cancelHTTPRequests()
    })
    result = response.data
  } catch (err) {
    throw new AppError({
      name: errorName,
      message: errorMessage,
      err
    })
  }
  return result
}
